
import lazyload from "@/directives/lazyload";
import lottie from "vue-lottie/src/lottie.vue";
import * as animationData from "@/assets/animations/sm-service.json";
export default {
  data() {
    return {
      anim: null, // for saving the reference to the animation
      lottieOptions: { animationData: animationData.default },
    };
  },
  directives: {
    lazyload,
  },
  components: {
    lottie,
  },

  methods: {

    handleAnimation: function (anim) {
      this.anim = anim;
    },
  }
};
